<template>
  
  <v-container class="_dati-azienda d-flex align-center justify-center text-center">
    <template v-if="!isLoading">
      <template v-if="datiAziendaPresenti">
        <div class="d-flex flex-column pa-5">

          <v-alert v-if="aziendaAssegnata" type="success" 
                    icon="business" elevation="5" :color="scdColor" outlined>
            <div class="d-flex align-center justify-space-between">
              <div class="d-flex flex-column align-start pr-3">
                <div class="_titolo">AZIENDA ASSEGNATA</div>
                <div class="_dato">{{ aziendaAssegnata }}</div>
              </div>
              <div>
                <v-btn
                  class="_copy_button"
                  v-clipboard:copy="aziendaAssegnata"
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onError">Copia
                </v-btn>
              </div>
            </div>
          </v-alert>

          <v-alert v-if="codiceIdentificativo" type="success" 
                    icon="fingerprint" elevation="5" :color="scdColor" outlined>
            <div class="d-flex align-center justify-space-between">
              <div class="d-flex flex-column align-start pr-3">
                <div class="_titolo">CODICE IDENTIFICATIVO</div>
                <div class="_dato">{{ codiceIdentificativo }}</div>
              </div>
              <div>
                <v-btn
                  class="_copy_button"
                  v-clipboard:copy="codiceIdentificativo"
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onError">Copia
                </v-btn>
              </div>
            </div>
          </v-alert>

          <v-alert v-if="nomeUtente" type="success" 
                    icon="account_circle" elevation="5" :color="scdColor" outlined>
            <div class="d-flex align-center justify-space-between">
              <div class="d-flex flex-column align-start pr-3">
                <div class="_titolo">NOME UTENTE</div>
                <div class="_dato">{{ nomeUtente }}</div>
              </div>
              <div>
                <v-btn
                  class="_copy_button"
                  v-clipboard:copy="nomeUtente"
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onError">Copia
                </v-btn>
              </div>
            </div>
          </v-alert>

          <v-alert v-if="password" type="success" 
                    icon="vpn_key" elevation="5" :color="scdColor" outlined>
            <div class="d-flex align-center justify-space-between">
              <div class="d-flex flex-column align-start pr-3">
                <div class="_titolo">PASSWORD</div>
                <div class="_dato">{{ password }}</div>
              </div>
              <div>
                <v-btn
                  class="_copy_button"
                  v-clipboard:copy="password"
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onError">Copia
                </v-btn>
              </div>
            </div>
          </v-alert>

          <v-alert v-if="pin" type="success" 
                    icon="fiber_pin" elevation="5" :color="scdColor" outlined>
            <div class="d-flex align-center justify-space-between">
              <div class="d-flex flex-column align-start pr-3">
                <div class="_titolo">PIN</div>
                <div class="_dato">{{ pin }}</div>
              </div>
              <div>
                <v-btn
                  class="_copy_button"
                  v-clipboard:copy="pin"
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onError">Copia
                </v-btn>
              </div>
            </div>
          </v-alert>

        </div>
      </template>

      <div v-else class="_titolo">
        NESSUN DATO
      </div>

    </template>
  
    <v-progress-circular v-else :size="70" :width="7" :color="scdColor" indeterminate></v-progress-circular>

  </v-container> 
</template>

<script>
import mixin from '../../mixins';

export default {
  props: ['idCliccatore'],
  data() {
    return {
      isLoading: true,
      datiAziendaPresenti: false,
      aziendaAssegnata: null,
      codiceIdentificativo: null,
      nomeUtente: null,
      password: null,
      pin: null,
      idUtente: null,

      // coloreBottoneCopia: 
      message: 'Copy These Text'
    }
  },
  created() {
    this.getDatiAzienda();
  },
  methods: {
    getDatiAzienda() {
      axios
       .get(`getDatiAzienda/`)
       .then(response => {
          if (response.data.datiAzienda != null) {
            this.datiAziendaPresenti = true;

            let datiAzienda = response.data.datiAzienda[0];

            this.aziendaAssegnata = datiAzienda.nome_azienda
            this.codiceIdentificativo = datiAzienda.codice_identificativo
            this.nomeUtente = datiAzienda.nome_utente
            this.password = datiAzienda.password
            this.pin = datiAzienda.pin
          }
        })
        .finally(() => {
          this.isLoading = false;
        })
    },
    onCopy: function (e) {
      // alert('You just copied: ' + e.text)
    },
    onError: function (e) {
      // alert('Failed to copy texts')
    }
  }
}
</script>

<style scoped lang="scss">
  ._dati-azienda ::v-deep {
      height: calc(100vh - 60px);
    ._titolo {
      font-weight: 700;
      font-size: 20px;
      color: #272727;
    }
    ._copy_button {
      margin-left: 10px;
      color: white;
      background-color: #6D94CD!important;
    }
    ._dato {
      font-size: 18px;
      color: #6D94CD;
    }
  }
</style>

